export const obtenerObrasUnicasPorPropiedad = (array) => {
  return array[0].reduce((temasUnicos, obra) => {
    if (!temasUnicos.includes(obra.temaObra)) {
      temasUnicos.push(obra.temaObra);
    }
    return temasUnicos;
  }, []);
};
